import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 未登陆时手机验证码修改密码
interface PhoneLoginData {
    phone: string,
    code: string,
    newpassword: string,
    repassword: string
}

export const ChangeByPhone = (json: PhoneLoginData): any => http.httpPost({
    url: httpApi.PassWord.changeByPhone,
    json
})

